<ng-container thr-parent-form>
    <div class="row mb-3 mb-sm-4" *ngIf="!!currentModelId">
        <div class="col-12">
            <p class="mb-0">
                {{ 'rate.form.current-model' | translate }}
                <span class="mat-h1 text-blue ml-2">
                    {{currentModelName}}
                </span>
            </p>
        </div>
    </div>
    <div class="row align-items-center mb-3 mb-sm-4">
        <div class="col-auto flex-shrink-1 flex-grow-1" *ngIf="!!currentModelId; else noCurrentModelId">
            <mat-form-field class="full-width">
                <mat-select name="model" [placeholder]="'rate.form.select-your-model' | translate" required [(ngModel)]="data.modelId" (ngModelChange)="onModelChange()" [compareWith]="compareId" #modelPortfolioCtrl="ngModel">
                    <ng-container *ngFor="let validModel of validModels">
                        <mat-option [value]="validModel.id" *ngIf="validModel.id.value !== currentModelId.value">
                            {{ validModel.name + ' - ' + validModel.riskProfileName }}
                        </mat-option>
                    </ng-container>
                </mat-select>
                <mat-error *ngIf="modelPortfolioCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <ng-template #noCurrentModelId>
            <div class="col-auto flex-shrink-1 flex-grow-1">
                <mat-form-field class="full-width">
                    <mat-select name="model" [placeholder]="'rate.form.select-your-model' | translate" required [(ngModel)]="data.modelId" (ngModelChange)="onModelChange()" [compareWith]="compareId" #modelPortfolioCtrl="ngModel">
                        <ng-container *ngFor="let validModel of validModels">
                            <mat-option [value]="validModel.id">
                                {{ validModel.name + ' - ' + validModel.riskProfileName }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                    <mat-error *ngIf="modelPortfolioCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </ng-template>
        <div class="col-auto mx-0">
            <button type="button" class="btn-download full-width mat-elevation-z0" color="blue" mat-flat-button [disabled]="!this.isSelected" (click)="onDownload()">
                PDF <i class="icon-download"></i>
            </button>
        </div>
    </div>
    <div class="row mb-3 mb-sm-4" *ngIf="showInvestment">
        <div class="col-12">
            <mat-form-field class="full-width">
                <input matInput name="initialInvestment" [placeholder]="'rate.form.initial-investment' | translate" disabled [value]="(data.investment | number: '1.0-2') + ' &euro;'" />
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p class="mb-0">
                {{ 'rate.form.assigned-rate' | translate }}
                <span class="mat-h1 text-blue ml-2"> {{ feedAmount | number: '1.0-2' }}% </span>
            </p>
        </div>
    </div>
</ng-container>
